import Head from "next/head";
import { useTranslation } from "next-i18next";
import { META_IMAGE, SITE_URL } from "@/utils/meta";

export default function SeoPageMeta({ seoPage }) {
  const { i18n } = useTranslation();
  const localePrefix = i18n.language === "az" ? "" : `/${i18n.language}`;
  const pageUrl = `${SITE_URL}${localePrefix}/${seoPage?.slug ?? ""}`;
  const title = seoPage?.meta_title ?? seoPage?.title ?? "";
  const description = seoPage?.meta_description ?? seoPage?.description ?? "";
  const image = seoPage?.og_image ?? META_IMAGE;

  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={pageUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Head>
  );
}
